import { render } from "./BlogFecha.vue?vue&type=template&id=18eaa8f0"
import script from "./BlogFecha.vue?vue&type=script&lang=js"
export * from "./BlogFecha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__